'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default =

function ($scope, $window) {
    "ngInject";
    $scope.menus = {};
    $scope.toggleMenu = function (id) {
        $scope.menus[id] = !$scope.menus[id];
    };

    $scope.newGallery = function () {
        $scope.sliderOptions = {
            startEvent: "GALLERY",
            slides: [],
            opts: {
                open: false,
                index: 0,
                history: false
            },
            onClose: function onClose() {
                $scope.sliderOptions.open = false;
            },
            showGallery: function showGallery(event, i) {
                event.preventDefault();
                event.stopImmediatePropagation();
                $scope.sliderOptions.opts.index = i || $scope.sliderOptions.opts.index;
                $scope.$broadcast($scope.sliderOptions.startEvent);
                $scope.sliderOptions.open = true;

                console.log('==== $scope.sliderOptions.startEvent ====');
                console.log($scope.sliderOptions.startEvent);
                console.log($scope);
            }
        };
        return $scope.sliderOptions;
    };

    $scope.enableSticky = false;

    var scrollbarElement = angular.element($window),
        onScrollEvent;

    function scrollbarYPos() {
        var position;
        if (typeof $window.scrollTop !== 'undefined') {
            position = $window.scrollTop;
        } else if (typeof $window.pageYOffset !== 'undefined') {
            position = $window.pageYOffset;
        } else {
            position = document.documentElement.scrollTop;
        }
        return position;
    }

    var onScroll = function onScroll() {
        //$scope.enableSticky = scrollbarYPos() >= 50;
        if (scrollbarYPos() >= 50 && $scope.enableSticky === false) {
            $scope.enableSticky = true;
        }
        if (scrollbarYPos() < 50 && $scope.enableSticky === true) {
            $scope.enableSticky = false;
        }
    };

    onScrollEvent = $scope.$apply.bind($scope, onScroll);
    scrollbarElement.on('scroll', onScrollEvent); // робить баг, що сторінка вічно сповзає
    scrollbarElement.on('resize', onScrollEvent);

    $scope.$on('destroy', function () {
        scrollbarElement.off('scroll', onScrollEvent);
        scrollbarElement.off('resize', onScrollEvent);
    });
};


// WEBPACK FOOTER //
// ./app/base/controllers/BaseGlobalCtrl.js